export default __webpack_public_path__ + "static/media/EnergyDistribution_bg.5f79031c.jpg";